import { Check } from "lucide-react";
import { Field, SelectField, TextArea } from "@/components/site/FormControls";
import { CheckList, toggleIn } from "./useQuote";
import { money } from "@/lib/api";
import { CUSTOMER_TYPES, OCCUPANCY } from "@/data/inspections";

export const StepService = ({ services, value, onSelect }) => (
  <div className="grid gap-3 sm:grid-cols-2">
    {services.map((s) => {
      const on = value === s.id;
      return (
        <button key={s.id} type="button" onClick={() => onSelect(s.id)} data-testid={`book-service-${s.id}`}
          className={`flex items-center gap-4 rounded-xl border p-3 text-left transition-colors ${on ? "border-gold bg-gold/10" : "border-slate-200 bg-white hover:border-gold/60"}`}>
          <img src={s.image} alt="" className="h-16 w-16 shrink-0 rounded-lg object-cover" />
          <div className="flex-1">
            <p className="font-semibold text-[#0B132B]">{s.name}</p>
            <p className="text-sm text-slate-500">From <span className="font-semibold text-[#0B132B]">{money(s.base_price)}</span> · {s.duration_minutes} min</p>
          </div>
          {on && <Check className="h-5 w-5 text-gold" />}
        </button>
      );
    })}
  </div>
);

export const StepProperty = ({ f, set, setF, options }) => (
  <div className="grid gap-5 sm:grid-cols-2">
    <Field label="Full property address" name="address" value={f.address} onChange={set} required testid="book-address" />
    <Field label="City" name="city" value={f.city} onChange={set} required half testid="book-city" />
    <div className="grid grid-cols-2 gap-4">
      <Field label="State" name="state" value={f.state} onChange={set} required half testid="book-state" />
      <Field label="ZIP" name="zip" value={f.zip} onChange={set} required half testid="book-zip" />
    </div>
    <SelectField label="Property type" name="property_type" value={f.property_type} onChange={set} options={options?.property_types || []} required half testid="book-property-type" />
    <Field label="Square footage" name="sqft" type="number" value={f.sqft} onChange={set} required half testid="book-sqft" />
    <Field label="Year built (if known)" name="year_built" value={f.year_built} onChange={set} half testid="book-year-built" />
    <Field label="Number of units" name="units" type="number" value={f.units} onChange={set} required half testid="book-units" />
    <SelectField label="Occupancy status" name="occupancy" value={f.occupancy} onChange={set} options={OCCUPANCY} required half testid="book-occupancy" />
    <CheckList title="Additional services" items={options?.additional_services} priceKey="price" selected={f.additional_services}
      onToggle={(n) => setF({ ...f, additional_services: toggleIn(f.additional_services, n) })} testid="book-addon" />
    <CheckList title="Special property conditions" items={options?.special_conditions} priceKey="surcharge" selected={f.special_conditions}
      onToggle={(n) => setF({ ...f, special_conditions: toggleIn(f.special_conditions, n) })} testid="book-condition" />
    <TextArea label="Special access instructions" name="access_instructions" value={f.access_instructions} onChange={set} placeholder="Lockbox code, gate, pets, tenant contact…" testid="book-access" />
  </div>
);

export const StepCustomer = ({ f, set }) => (
  <div className="grid gap-5 sm:grid-cols-2">
    <Field label="Full name" name="full_name" value={f.full_name} onChange={set} required testid="book-full-name" />
    <Field label="Email" name="email" type="email" value={f.email} onChange={set} required half testid="book-email" />
    <Field label="Phone" name="phone" type="tel" value={f.phone} onChange={set} required half testid="book-phone" />
    <SelectField label="I am a" name="customer_type" value={f.customer_type} onChange={set} options={CUSTOMER_TYPES} required testid="book-customer-type" />
    <TextArea label="Additional notes" name="notes" value={f.notes} onChange={set} testid="book-notes" />
  </div>
);
